import { useIdleTimer } from 'react-idle-timer'

interface IProps {
    onIdle: () => void;
    timeout: number;
    timerRef: any;
}

export const IdleTimer = ({onIdle, timeout, timerRef}: IProps) => {
    useIdleTimer({
        onIdle,
        timeout,
        element: timerRef?.current,
    })
    return (
        <></>
    )
}